module.exports = __webpack_public_path__ + "static/media/event-schedule.d7861c72.svg";